// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import FormDialog from '../../components/Dialog/FormDialog';
import TextInput from '../../components/Form/TextInput';
import { DialogProps } from './DialogProps';

export const CommercialAgreementTopupDialog: React.FC<
  DialogProps & { onChangeTopupAmount?: (topupAmount: string) => Promise<unknown> }
> = ({ open, onClose, onChangeTopupAmount }) => {
  const [amount, setAmount] = React.useState('');
  const handleClose = React.useCallback(() => {
    setAmount('');
    onClose();
  }, [onClose]);
  const handleSubmit = React.useCallback(() => {
    if (onChangeTopupAmount) {
      return onChangeTopupAmount(amount).finally(() => {
        handleClose();
      });
    }
    handleClose();
    return Promise.resolve();
  }, [amount, handleClose, onChangeTopupAmount]);
  return (
    <FormDialog
      open={open}
      title="Top up"
      onCancel={onClose}
      submitName="Top up"
      onSubmit={handleSubmit}
    >
      <TextInput label="Top up amount (CC) " value={amount} setValue={setAmount} />
    </FormDialog>
  );
};
